import {
  Div,
  H5,
  isPartner,
  P,
  Separator,
  TaxClassification,
} from '@vgrubs/components';
import { renderAccountType } from './helpers';
import { AccountType } from '../../hooks/useWalletV2';

export const Confirmation = ({
  accountNumber,
  routingNumber,
  accountType,
  businessName,
  address,
  taxClassification,
}: {
  accountNumber: string;
  routingNumber: string;
  accountType: AccountType;
  businessName: string;
  address: string;
  taxClassification: TaxClassification;
}) => {
  return (
    <Div $flex $column $gap="24px">
      <P $m="0">
        Double-check {isPartner ? 'your' : 'this account'} info before
        connecting.
      </P>
      <Div>
        <P $m="0">Account Number</P>
        <H5 $m="0">{accountNumber}</H5>
        <Separator $m="16px 0" />
        <P $m="0">Routing Number</P>
        <H5 $m="0">{routingNumber}</H5>
        <Separator $m="16px 0" />
        <P $m="0">Account Type</P>
        <H5 $m="0">
          {renderAccountType(
            accountType === AccountType.business
              ? taxClassification
              : TaxClassification.individual
          )}
        </H5>
        {accountType === AccountType.business && (
          <>
            <Separator $m="16px 0" />
            <P $m="0">Business Name</P>
            <H5 $m="0">{businessName}</H5>
          </>
        )}

        <Separator $m="16px 0" />
        <P $m="0">Address</P>
        <H5 $m="0">{address}</H5>
        <Separator $m="16px 0" />
      </Div>
    </Div>
  );
};
